import { gql } from '@apollo/client';
import KEY_SCHEDULED_ACTIVITY_SETTINGS from '../fragments/keyboarding-scheduled-activity-settings';
import KEYBOARDING_ENRICHMENT_SETTING from '../fragments/keyboarding-enrichments-setting';
import KEYBOARDING_HOME_USE_SETTING from '../fragments/keyboarding-home-use-setting';

const KEYBOARDING_CLASSROOM_SETTINGS_FRAGMENT = gql`
  fragment BaseKeyboardingClassroomSettings on KeyClassroomSettings {
    homeUse {
      enabled
      students {
        studentId
        productCurriculumCode
        homeUse {
          ...BaseKeyHomeUseSetting
        }
      }
    }
    skipJumpIn {
      enabled
    }
    stopAndReview {
      week
      enabled
    }
    assessmentSettings {
      ...BaseKeyScheduledActivitySettings
    }
    enrichmentActivitySettings {
      ...BaseKeyEnrichmentActivitySettings
    }
    assessmentAcceleratorSettings {
      activityTypeId
      scheduledDates {
        date
        moduleIds
      }
    }
  }
  ${KEY_SCHEDULED_ACTIVITY_SETTINGS}
  ${KEYBOARDING_ENRICHMENT_SETTING}
  ${KEYBOARDING_HOME_USE_SETTING}
`;

export default KEYBOARDING_CLASSROOM_SETTINGS_FRAGMENT;
